module.exports = ".btn-primary{\r\n    float: right;\r\n}\r\n.row{\r\n    margin-bottom: 10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-reports/sainik-reports-pages/sainik-reports-pages.component.css
// module id = ./src/app/sainik-reports/sainik-reports-pages/sainik-reports-pages.component.css
// module chunks = main